
export default function authOctetHeader () {
  return { accept: 'application/octet-stream' }
}
